import React from "react";

const RatingProgressBar = ({ product, reviews }) => {
  // console.log("product && product.numOfReviews:", product);
  return (
    <div className="md:p-12 flex flex-col justify-self-stretch">
      <div>
        <div className="flex items-center sm:px-8 px-0">
          <div className="w-12 text-2xl items-center flex">
            <p className="mb-0">5</p>
            <span>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </span>
          </div>

          <div className="w-full sm:ml-8 ml-4 rounded-full bg-gray-100">
            <div
              className="text-tn-rating-green bg-tn-rating-green text-transparent text-xs font-medium text-center leading-none rounded-full"
              style={{ width: `${reviews.summary[5].percentage}%` }}
            >
              {reviews.summary[1].percentage === 0 ? (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-white text-xs"
                >
                  &nbsp
                </p>
              ) : (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-tn-rating-green text-xs"
                >
                  &nbsp
                </p>
              )}
            </div>
          </div>
          <div className="ml-5">{reviews.summary[5].count}</div>
        </div>

        <div className="flex items-center sm:px-8 px-0">
          <div className="w-12 text-2xl items-center flex ">
            <p className="mb-0">4</p>
            <span>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </span>
          </div>

          <div className="w-full sm:ml-8 ml-4 rounded-full bg-gray-100">
            <div
              className=" bg-tn-rating-green text-tn-rating-green text-transparent text-xs font-medium text-center  leading-none rounded-full"
              style={{ width: `${reviews.summary[4].percentage}%` }}
            >
              {reviews.summary[1].percentage === 0 ? (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-white text-xs"
                >
                  &nbsp
                </p>
              ) : (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-tn-rating-green text-xs"
                >
                  &nbsp
                </p>
              )}
            </div>
          </div>
          <div className="ml-5">{reviews.summary[4].count}</div>
        </div>

        <div className="flex items-center sm:px-8 px-0">
          <div className="w-12 text-2xl items-center flex ">
            <p className="mb-0">3</p>
            <span>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </span>
          </div>

          <div className="w-full sm:ml-8 ml-4 rounded-full bg-gray-100 ">
            <div
              className=" bg-tn-rating-green text-tn-rating-green text-transparent text-xs font-medium text-center  leading-none rounded-full"
              style={{ width: `${reviews.summary[3].percentage}%` }}
            >
              {reviews.summary[1].percentage === 0 ? (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-tn-rating-green w-4 text-xs"
                >
                  &nbsp
                </p>
              ) : (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-tn-rating-green w-4 text-xs"
                >
                  sdf
                </p>
              )}
            </div>
          </div>
          <div className="ml-5">{reviews.summary[3].count}</div>
        </div>

        <div className="flex items-center sm:px-8 px-0">
          <div className="w-12 text-2xl items-center flex ">
            <p className="mb-0">2</p>
            <span>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </span>
          </div>

          <div className="w-full sm:ml-8 ml-4 rounded-full bg-gray-100">
            <div
              className=" bg-tn-rating-yellow text-tn-rating-yellow text-transparent text-xs font-medium text-center  leading-none rounded-full"
              style={{ width: `${reviews.summary[2].percentage}%` }}
            >
              {reviews.summary[1].percentage === 0 ? (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-white text-xs"
                >
                  &nbsp
                </p>
              ) : (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-tn-rating-yellow text-xs"
                >
                  &nbsp
                </p>
              )}
            </div>
          </div>
          <div className="ml-5">{reviews.summary[2].count}</div>
        </div>

        <div className="flex items-center sm:px-8 px-0">
          <div className="w-12 text-2xl items-center flex ">
            <p className="mb-0">1</p>
            <span>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </span>
          </div>

          <div className="w-full sm:ml-8 ml-4 rounded-full bg-gray-100">
            <div
              className="bg-tn-rating-orange text-tn-rating-orange text-transparent text-xs font-medium text-center  leading-none rounded-full"
              style={{ width: `${reviews.summary[1].percentage}%` }}
            >
              {reviews.summary[1].percentage === 0 ? (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-white text-xs"
                >
                  &nbsp
                </p>
              ) : (
                <p
                  style={{ color: "rgba(234, 240, 246, 0)" }}
                  className="text-tn-rating-orange text-xs"
                >
                  &nbsp
                </p>
              )}
            </div>
          </div>
          <div className="ml-5">{reviews.summary[1].count}</div>
        </div>
      </div>

      <div>
        <div className="sm:text-5xl text-3xl self-end sm:mt-12 mt-6 text-center items-center justify-center flex">
          <h1>
            {product && product.rating
              ? Math.round(product.rating * 10) / 10
              : null}
          </h1>
          <span>
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          </span>
        </div>

        <div className="text-2xl mx-auto font-medium text-center max-w-2xl text-gray-400">
          {product && product.numOfReviews} Reviews
        </div>
      </div>
    </div>
  );
};

export default RatingProgressBar;
